export default __webpack_public_path__ + "static/media/newLoginLogo.9d65743e.svg";